import clsx from 'clsx';
import React from 'react';

import { Env } from '@contexts/AppContext';
import { getImgxSrc } from '@utils/images';

import style from '../../pages/Article/styles.module.scss';

interface TestimonialProps {
  env: Env;
}

interface TestimonialData {
  name: string;
  title: string;
  quote: string;
  img: string;
}

const TESTIMONIAL_DATA: TestimonialData[] = [
  {
    name: 'Vinod Khosla',
    title: 'Founder, Khosla Ventures',
    quote:
      'The Information is one of the few trusted sources of tech news that I reference on a daily basis.”',
    img: 'vinod_khosla.png',
  },
  {
    name: 'Julia Hartz',
    title: 'CEO, Eventbrite',
    quote: 'I subscribe to The Information because it is the highest quality news in tech today.”',
    img: 'julia_hartz.png',
  },
];

const Testimonial = ({ env }: TestimonialProps) => {
  return (
    <aside className={style.articleBody}>
      <h3 className="my-0 font-suisse-intl-mono text-overline-md text-primary-magenta">
        Our subscribers say
      </h3>
      <div className="mb-80 flex flex-col items-center gap-[48px] sm:flex-row sm:items-baseline sm:gap-[69px] md:justify-between md:gap-[59px] lg:gap-[159px]">
        {TESTIMONIAL_DATA.map((testimonial, index) => (
          <div
            key={testimonial.name}
            className={clsx(
              'w-full max-w-full border-0 border-b-[3px] border-solid border-primary-magenta',
              {
                'mt-32': index === 0,
                'mt-0 sm:mt-32': index === 1,
              }
            )}
          >
            <div className="pull-quote !mb-16 !mt-32 !min-h-[60px] before:!-ml-10 before:!max-h-0 before:!text-[200px] sm:!mt-0" />
            <div className="mb-24 font-suisse-neue text-body-md sm:max-w-[300px] md:max-w-[440px]">
              {testimonial.quote}
            </div>
            <img
              src={getImgxSrc({
                path: `about/${testimonial.img}`,
                isDevDependence: true,
                envContext: env,
              })}
              className="mb-24 h-90 w-90 rounded-full"
            />
            <div className="font-suisse-screen">
              <span className="text-byline-lg">{testimonial.name}</span> |{' '}
              <span className="text-byline-md">{testimonial.title}</span>
            </div>
          </div>
        ))}
      </div>
    </aside>
  );
};

export default Testimonial;
